import popper from 'popper.js';
import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';

if (!watchlistBtnScriptLoaded) {
    watchlistBtnScriptLoaded = true;
    
    document.addEventListener('DOMContentLoaded', function() {
        function initializeWatchlistButtons() {
            tippy('.watchlist-btn', {
                content: "Please login to add to watchlist",
                arrow: true,
                arrowType: 'sharp',
                animation: 'fade',
                placement: 'top',
                // followCursor: true,
                // followCursor: 'initial',
                // plugins: [followCursor],
                // placement: 'right-start',
                hideOnClick: true
            });
        }

        if (loggedIn) {
            $(".watchlist-btn").click(function(){
                var watchlist_add_title_id = $(this).data('title-id');
                var watchlist_title_added = $(this).data('added-to-watchlist');

                var icon = $(this).find('.fas');
                var icon_fa_icon = icon.attr('data-icon');

                $(this).toggleClass('button-action');

                if(icon_fa_icon === 'plus') {
                    icon.attr('data-icon', 'check');
                    icon.addClass("fa-check");
                    icon.removeClass("fa-plus");
                } else {
                    icon.attr('data-icon', 'plus');
                    icon.addClass("fa-plus");
                    icon.removeClass("fa-check");
                }


                if ($(this).val() == "true") {
                    $.ajax({
                        type: "DELETE",
                        url: "/watchlist",
                        data: {
                            titleId: watchlist_add_title_id
                        },
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        success: function() {
                            $("#watchlist-btn").val("false");
                        }
                    });
                } else {
                    $.ajax({
                        type: "POST",
                        url: "/watchlist",
                        data: {
                            titleId: watchlist_add_title_id
                        },
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        success: function() {
                            $("#watchlist-btn").val("true");
                        }
                    });
                }
            });


            $(".watchlist-bookmark").each(function(){
                var loop_title_id = $(this).data('title-id');

                if(watchlist_add_title_id == loop_title_id) {
                    var icon = $(this).find('.fas');
                    var icon_fa_icon = icon.attr('data-icon');

                    if(icon_fa_icon === 'plus') {
                        icon.attr('data-icon', 'check');
                        $(this).addClass("ribbon-added");
                        $(this).removeClass("ribbon-light");
                    } else {
                        icon.attr('data-icon', 'plus');
                        $(this).removeClass("ribbon-added");
                        $(this).addClass("ribbon-light");
                    }
                }
            });
        } else {
            initializeWatchlistButtons();

            $(".container").on("click", ".watchlist-btn", function() {
                var watchlist_add_title_id = $(this).data('title-id');
                var watchlist_title_added = $(this).data('added-to-watchlist');
                var watchlist_post_route = $(this).data('post-to-watchlist');

                // window.location.href = watchlist_post_route;
                window.location.href = redirectRoute;
            });
        }
    })
}